import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import styles from '../Sidebar.module.scss'
import Cookies from 'universal-cookie'

const SidebarItems = ({ items, getHandler }) => {
  const { pathname } = useLocation()
  const [user, setUser] = useState('')
  const [userId, setUserId] = useState('')
  const [img, setImg] = useState('')

  const cookies = new Cookies()

  const toggleTheme = (selectedTheme) => {
    if (selectedTheme === 'light') {
      document.documentElement.setAttribute('data-theme', 'light-theme')
    } else if (selectedTheme === 'dark') {
      document.documentElement.removeAttribute('data-theme')
    }

    localStorage.setItem('theme', selectedTheme)
  }

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      toggleTheme(savedTheme)
    }
  }, [])

  useEffect(() => {
    const accessToken = cookies.get('access_token')
    const tokenType = cookies.get('token_type')

    fetch('https://discord.com/api/users/@me', {
      method: 'GET',
      headers: {
        authorization: `${tokenType} ${accessToken}`,
      },
    })
      .then((result) => {
        if (result.ok) {
          return result.json()
        }
        cookies.remove('access_token')
        cookies.remove('token_type')
        window.location.replace('/')
        alert('Unauthorized access! Please log in.')
        throw new Error(`Request failed with status: ${result.status}`)
      })
      .then((response) => {
        setUser(response.username)
        setUserId(response.id)
        setImg(response.avatar)
      })
      .catch(console.error)
  }, [])

  function handleLogout() {
    cookies.remove('access_token')
    cookies.remove('token_type')
    window.location.replace('/')
  }

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.menu}>MENU</div>

        <ul className={styles.list}>
          {items?.map((item) => (
            <li key={item?.text}>
              <NavLink
                to={item?.route}
                className={`${styles.listItem} ${
                  pathname === item?.route ? styles.active : styles.notActive
                }`}
                onClick={() => getHandler(item?.text)}
              >
                <img src={item?.src} alt={item?.alt} />
                <span>{item?.text}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.option}>
        <div className={styles.setting}>
          <div className={styles.info}>
            <img
              src={`https://cdn.discordapp.com/avatars/${userId}/${img}.jpg`}
              alt="logo2"
            />

            <span>{user}</span>
          </div>

          <div className={styles.color}>
            <button
              className={styles.light}
              onClick={() => toggleTheme('light')}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12.003 18C13.5943 18 15.1204 17.3679 16.2456 16.2426C17.3709 15.1174 18.003 13.5913 18.003 12C18.003 10.4087 17.3709 8.88258 16.2456 7.75736C15.1204 6.63214 13.5943 6 12.003 6C10.4117 6 8.88558 6.63214 7.76036 7.75736C6.63514 8.88258 6.003 10.4087 6.003 12C6.003 13.5913 6.63514 15.1174 7.76036 16.2426C8.88558 17.3679 10.4117 18 12.003 18ZM11.9985 1.5C12.5505 1.5 12.999 1.947 12.999 2.5005V3.501C12.9978 3.76598 12.892 4.01978 12.7047 4.20715C12.5173 4.39453 12.2635 4.50032 11.9985 4.5015C11.4465 4.5015 10.998 4.0545 10.998 3.501V2.5005C10.998 1.9485 11.445 1.5 11.9985 1.5ZM11.9985 19.5C12.5505 19.5 12.999 19.947 12.999 20.5005V21.498C12.9978 21.763 12.892 22.0168 12.7047 22.2042C12.5173 22.3915 12.2635 22.4973 11.9985 22.4985C11.4465 22.4985 10.998 22.0515 10.998 21.498V20.5005C10.998 19.9485 11.445 19.5 11.9985 19.5ZM1.5 11.9985C1.5 11.4465 1.947 10.998 2.5005 10.998H3.501C4.053 10.998 4.5015 11.445 4.5015 11.9985C4.5015 12.552 4.0545 12.999 3.501 12.999H2.5005C1.9485 12.999 1.5 12.552 1.5 11.9985ZM19.5 11.9985C19.5 11.4465 19.947 10.998 20.5005 10.998H21.4965C22.0485 10.998 22.497 11.445 22.497 11.9985C22.497 12.552 22.05 12.999 21.4965 12.999H20.5005C19.9485 12.999 19.5 12.552 19.5 11.9985ZM4.575 19.422C4.38859 19.2338 4.28402 18.9796 4.28402 18.7147C4.28402 18.4499 4.38859 18.1957 4.575 18.0075L5.2815 17.301C5.46969 17.1146 5.72387 17.01 5.98875 17.01C6.25363 17.01 6.50781 17.1146 6.696 17.301C7.0875 17.691 7.086 18.324 6.696 18.7155L5.9895 19.422C5.80131 19.6084 5.54713 19.713 5.28225 19.713C5.01737 19.713 4.76319 19.6084 4.575 19.422ZM17.3025 6.6945C17.1161 6.50631 17.0115 6.25213 17.0115 5.98725C17.0115 5.72237 17.1161 5.46819 17.3025 5.28L18.0075 4.575C18.1957 4.38859 18.4499 4.28402 18.7147 4.28402C18.9796 4.28402 19.2338 4.38859 19.422 4.575C19.8135 4.965 19.812 5.598 19.422 5.9895L18.717 6.6945C18.5288 6.88091 18.2746 6.98548 18.0098 6.98548C17.7449 6.98548 17.4907 6.88091 17.3025 6.6945ZM4.575 4.575C4.76319 4.38859 5.01737 4.28402 5.28225 4.28402C5.54713 4.28402 5.80131 4.38859 5.9895 4.575L6.696 5.2815C6.88241 5.46969 6.98698 5.72387 6.98698 5.98875C6.98698 6.25363 6.88241 6.50781 6.696 6.696C6.306 7.0875 5.673 7.086 5.2815 6.696L4.575 5.9895C4.38859 5.80131 4.28402 5.54713 4.28402 5.28225C4.28402 5.01737 4.38859 4.76319 4.575 4.575ZM17.3025 17.3025C17.4907 17.1161 17.7449 17.0115 18.0098 17.0115C18.2746 17.0115 18.5288 17.1161 18.717 17.3025L19.422 18.0075C19.6084 18.1957 19.713 18.4499 19.713 18.7147C19.713 18.9796 19.6084 19.2338 19.422 19.422C19.032 19.8135 18.399 19.812 18.0075 19.422L17.3025 18.717C17.1161 18.5288 17.0115 18.2746 17.0115 18.0098C17.0115 17.7449 17.1161 17.4907 17.3025 17.3025Z"
                  fill="var(--font-light-color)"
                />
              </svg>
              Light
            </button>

            <button className={styles.dark} onClick={() => toggleTheme('dark')}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M8.0655 6.02547C6.213 7.28697 4.9995 9.41097 4.9995 11.817C5.00109 13.673 5.7392 15.4525 7.05174 16.7648C8.36429 18.0771 10.144 18.8148 12 18.816C14.4045 18.816 16.53 17.6025 17.7915 15.75C15.307 15.4738 12.9905 14.3603 11.2228 12.5926C9.4552 10.825 8.34172 8.50847 8.0655 6.02397V6.02547ZM19.0005 13.8165C19.866 13.8165 20.613 14.58 20.2695 15.375C18.8895 18.576 15.7065 20.817 12 20.817C9.61305 20.817 7.32387 19.8688 5.63604 18.1809C3.94821 16.4931 3 14.2039 3 11.817C3 8.11047 5.241 4.92747 8.442 3.54747C9.237 3.20547 10.0005 3.95097 10.0005 4.81647C10.0005 7.20342 10.9487 9.49261 12.6365 11.1804C14.3244 12.8683 16.6136 13.8165 19.0005 13.8165Z"
                  fill="#FCFCFC"
                />
              </svg>
              Dark
            </button>
          </div>
        </div>

        <div className={styles.button}>
          <NavLink onClick={handleLogout} className={styles.logout}>
            Log Out
          </NavLink>

          <NavLink to="/" className={styles.support}>
            Support
          </NavLink>
        </div>
      </div>
    </div>
  )
}

export default SidebarItems
